import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import OktaLogin from '../components/login';
import * as Utils from '../utils.js';
import * as Actions from '../actions/appActions';
import Footer from '../components/footer';
import PortalHeader from '../components/portalHeader';

const ConnectedOktaLogin = connect(state => {
    if (state.oktaLogin && state.oktaLogin.data) {
        return {
            status: state.oktaLogin.data.status || '',
            stateToken: state.oktaLogin.data.stateToken || '',
            factorId: state.oktaLogin.data.factorId,
            userId: state.oktaLogin.data.userId,
            userName: state.oktaLogin.data.userName,
            href: state.oktaLogin.data.href,
            sessionToken: state.oktaLogin.data.sessionToken,
            verifyToken: state.oktaLogin.data.verifyToken,
            answer: state.oktaLogin.data.answer,
            securityQuestion: state.oktaLogin.data.securityQuestion,
            passwordComplexity: state.oktaLogin.data.passwordComplexity,
            error: state.oktaLogin.error || null,
            loading: state.oktaLogin.loading,
            sharedSecret: state.oktaLogin.data.sharedSecret,
            userEmail: state.oktaLogin.data.userEmail,
        };
    } else {
        return {
            status: '',
            error: (state.oktaLogin && state.oktaLogin.error) || null,
            loading: (state.oktaLogin && state.oktaLogin.loading) || false,
        };
    }
})(OktaLogin);

class SetCredentials extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: null,
            userType: _.get(this.props, 'location.state.userType'),
        };
    }

    getUserEmail(props) {
        const user = _.get(props, 'location.state.user');
        return user || null;
    }

    routeNavigation(nextProps) {
        if (this.state.userType === 'api' || nextProps.userType === 'api') {
            this.props.dispatch(Actions.ApplicationTabSelected({ Url: '/apiUserCreationConfirmation' }));
        } else {
            this.state.user && this.props.dispatch(Actions.AuthorizeUser(this.state.user, nextProps.tenant));
            this.props.dispatch(Actions.RedirectToApplication('/securityQuestion'));
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.jwt != '') {
            if (this.props.jwt != nextProps.jwt) {
                Utils.setIdToken(nextProps.jwt);
                this.routeNavigation(nextProps);
            }
        }
    }

    componentDidMount() {
        let user = Utils.loadUserProfile();

        if (this.getUserEmail(this.props)) {
            this.setState({ user: this.getUserEmail(this.props) }, () => {
                this.props.dispatch(Actions.PreAuthorizeUser(this.getUserEmail(this.props), this.props.tenant));
            });
        }

        if (this.props.location.state.vt && this.props.location.state.a) {
            this.props.dispatch(Actions.VerifyAndAnswer(this.props.location.state.vt, this.props.location.state.a));
        } else {
            this.props.dispatch(Actions.VerifyAndAnswer(null, null));
        }
    }

    render() {
        const isApiUser = this.state.userType === 'api';
        return (
            <div className="sign-in-wrapper">
                <PortalHeader />
                <div>{this.props.status != '' ? <ConnectedOktaLogin isApiUser={isApiUser} /> : null}</div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        jwt: (state.oktaLogin && state.oktaLogin.data && state.oktaLogin.data.jwt) || '',
        url: (state.taber && state.taber.selectedItem && state.taber.selectedItem.Url) || '',
        status: (state.oktaLogin && state.oktaLogin.data && state.oktaLogin.data.status) || '',
        tabItems: state.taber && state.taber.data && state.taber.data.payload,
        tenant: state.serviceOverviewToolbar.tenant,
        userType: state.oktaLogin && state.oktaLogin.data && state.oktaLogin.data.userDetails && state.oktaLogin.data.userDetails.userType,
    };
};

export default connect(mapStateToProps)(SetCredentials);
